import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { ModalOption } from '../../../stores/modalStore';
import { Modal } from './Modal';

const ConfirmModal = observer(({ modalId, option }: { modalId: string; option: ModalOption }) => {
    const [isChecked, setIsChecked] = useState(false);

    const hasCheckbox = !!option.confirm?.checkbox;
    const isCheckboxRequired = option.confirm?.checkbox?.required ?? false;
    const canConfirm = !hasCheckbox || !isCheckboxRequired || isChecked;
    const confirmStyle = option.confirm?.confirmStyle ?? 'default';

    return (
        <Modal.Dialog modalId={modalId}>
            <Modal.BodyScroll>
                <p>{option.confirm?.message}</p>
                {hasCheckbox && (
                    <div className="form-control mt-8">
                        <label className="label cursor-pointer justify-start gap-2">
                            <input
                                type="checkbox"
                                className="checkbox checkbox-sm"
                                checked={isChecked}
                                onChange={(e) => setIsChecked(e.target.checked)}
                            />
                            <span className="label-text text-base-content text-base">
                                {option.confirm?.checkbox?.text}
                            </span>
                        </label>
                    </div>
                )}
            </Modal.BodyScroll>
            <Modal.ActionButton
                modalId={modalId}
                confirmStyle={confirmStyle}
                isShowCancel={true}
                canConfirm={canConfirm}
                cancelText={option.confirm?.cancelText}
                confirmText={option.confirm?.confirmText}
            />
        </Modal.Dialog>
    );
});

export default ConfirmModal;
